import StackIconMapper from "@/components/shared/stack-iconmapper";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { STACKS } from "../about/about-contents";
import HomeSectionTitle from "./components/home-section-title";
import { cn } from "@/lib/utils";
import { Check } from "lucide-react";
import HomeStackGraph from "./components/home-stack-graph";
import HomeSectionDescription from "./components/home-section-description";

export default function HomeStack() {
  return (
    <div className="grid ">
      <HomeSectionTitle className="text-zinc-50 text-3xl font-montserrat leading-relaxed">
        Stack
      </HomeSectionTitle>
      <HomeSectionDescription className="max-w-[80%] md:max-w-[700px] text-base mb-8">
        최신 프론트엔드 트렌드를 반영해 구조적 설계와 렌더링 최적화에 집중하고,
        협업과 서비스 품질 향상을 위해 백엔드와 인프라를 함께 이해하며
        개발합니다.
      </HomeSectionDescription>
      <ul className="gap-16 grid ">
        <div className="grid grid-cols-1">
          {/* Graph */}
          <div className="col-span-full">
            <HomeStackGraph />
          </div>
          <div className="grid  grid-cols-1 gap-20 mt-20">
            {STACKS.map(({ category, stacks, trigger }, i) => (
              <li
                key={`${category}-${i}`}
                className={cn(
                  "rounded-lg flex flex-col items-start"
                  // i === 0 && "col-span-2"
                )}
              >
                <div className="flex flex-col mb-6">
                  {/* <div className="flex items-start justify-between mb-4">
                    <span className="text-[10px] text-zinc-500 tracking-wider">
                      value 0{i + 1}
                    </span>
                  </div> */}
                  <h3 className="flex items-center gap-2 text-xl mb-4">
                    <span
                      className={cn(
                        "text-zinc-200 font-semibold font-montserrat"
                      )}
                    >
                      {category}
                    </span>
                    {category === "Front-end" && (
                      <span className="text-xs px-2 py-0.5 rounded-full  text-pink-400 ">
                        <Check />
                      </span>
                    )}
                  </h3>{" "}
                  <p className="text-zinc-400 text-sm max-w-[450px] leading-relaxed break-keep">
                    {trigger}
                  </p>
                </div>

                <TooltipProvider>
                  <div className={cn(" gap-2 w-full")}>
                    <div className="max-w-[750px] flex flex-wrap gap-2">
                      {stacks.map(({ name, description }, idx) => (
                        <Tooltip key={idx}>
                          <TooltipTrigger asChild>
                            <div className="flex items-center p-2 bg-zinc-800/30 gap-3 group rounded-lg  hover:bg-zinc-50/10 transition-colors">
                              <StackIconMapper
                                stackName={name}
                                className="size-5 grayscale-100 group-hover:grayscale-0 text-zinc-300 hover:text-zinc-100 transition-colors"
                              />
                              <span className="text-xs text-zinc-400 group-hover:text-zinc-50">
                                {name}
                              </span>
                            </div>
                          </TooltipTrigger>
                          <TooltipContent className="bg-indigo-500/90 text-zinc-50 border border-zinc-700 shadow-md text-xs">
                            <span className="font-semibold">{name}</span>
                            <br />
                            {description}
                          </TooltipContent>
                        </Tooltip>
                      ))}
                    </div>
                  </div>
                </TooltipProvider>
              </li>
            ))}
          </div>
        </div>
      </ul>
    </div>
  );
}
